import { DocumentType } from '../../../../enums/document-type';
import { messages } from './messages';

export const documentTypeToRealProps = {
  [DocumentType.PickList.identifier]: {
    getTitleTranslation: () => messages.pickListTitle,
    getPrintDefaultMessageDescriptor: () => messages.pickListPrintDefault,
    getFileNameTranslation: () => messages.pickListFileName,
  },
  [DocumentType.BatchPickList.identifier]: {
    getTitleTranslation: () => messages.pickListTitle,
    getPrintDefaultMessageDescriptor: () => messages.pickListPrintDefault,
  },
  [DocumentType.OrderSummary.identifier]: {
    getTitleTranslation: () => messages.orderSummaryTitle,
    getPrintDefaultMessageDescriptor: () => messages.orderSummaryPrintDefault,
  },
  [DocumentType.PackingSlip.identifier]: {
    getTitleTranslation: () => messages.packingSlipTitle,
    getPrintDefaultMessageDescriptor: () => messages.packingSlipPrintDefault,
    getFileNameTranslation: () => messages.packingSlipFileName,
  },
  [DocumentType.Label.identifier]: {
    getTitleTranslation: () => messages.labelTitle,
    getPrintDefaultMessageDescriptor: () => messages.labelPrintDefault,
    getFileNameTranslation: () => messages.labelFileName,
  },
  [DocumentType.CustomsForm.identifier]: {
    getTitleTranslation: () => messages.customsFormsTitle,
    getPrintDefaultMessageDescriptor: () => messages.customsFormsPrintDefault,
  },
  [DocumentType.BatchCustomsForm.identifier]: {
    getTitleTranslation: () => messages.customsFormsTitle,
    getPrintDefaultMessageDescriptor: () => messages.customsFormsPrintDefault,
  },
  [DocumentType.EndOfDayForm.identifier]: {
    getTitleTranslation: () => messages.endOfDayFormTitle,
    getPrintDefaultMessageDescriptor: () => messages.endOfDayFormPrintDefault,
  },
  [DocumentType.BatchLabel.identifier]: {
    getTitleTranslation: () => messages.labelTitle,
    getPrintDefaultMessageDescriptor: () => messages.labelPrintDefault,
  },
  [DocumentType.BatchPackingSlip.identifier]: {
    getTitleTranslation: () => messages.packingSlipTitle,
    getPrintDefaultMessageDescriptor: () => messages.packingSlipPrintDefault,
  },
  [DocumentType.HotkeysAndBarcode.identifier]: {
    getTitleTranslation: () => messages.hotkeysAndBarcodeTitle,
    getPrintDefaultMessageDescriptor: () => messages.hotkeysAndBarcodePrintDefault,
  },
  [DocumentType.ShipmentManifest.identifier]: {
    getTitleTranslation: () => messages.shipmentManifestTitle,
    getPrintDefaultMessageDescriptor: () => messages.shipmentManifestPrintDefault,
  },
  [DocumentType.BatchShipmentManifest.identifier]: {
    getTitleTranslation: () => messages.shipmentManifestTitle,
    getPrintDefaultMessageDescriptor: () => messages.shipmentManifestPrintDefault,
  },
  [DocumentType.OtherForms.identifier]: {
    getTitleTranslation: () => messages.otherFormsTitle,
    getPrintDefaultMessageDescriptor: () => messages.otherFormsPrintDefault,
  },
  [DocumentType.WarehouseLabels.identifier]: {
    getTitleTranslation: () => messages.warehouseLabelsTitle,
    getPrintDefaultMessageDescriptor: () => messages.warehouseLabelsPrintDefault,
  },
  [DocumentType.PurchaseOrder.identifier]: {
    getTitleTranslation: () => messages.purchaseOrderTitle,
    getPrintDefaultMessageDescriptor: () => messages.purchaseOrderPrintDefault,
    getFileNameTranslation: () => messages.purchaseOrderFileName,
  },
  [DocumentType.LocationBarcode.identifier]: {
    getTitleTranslation: () => messages.locationBarcodeTitle,
    getPrintDefaultMessageDescriptor: () => messages.locationBarcodePrintDefault,
    getFileNameTranslation: () => messages.locationBarcodeFileName,
  },
  [DocumentType.UomBarcode.identifier]: {
    getTitleTranslation: () => messages.uomBarcodeTitle,
    getPrintDefaultMessageDescriptor: () => messages.uomBarcodePrintDefault,
    getFileNameTranslation: () => messages.uomBarcodeFileName,
  },
  [DocumentType.FreightDocument.identifier]: {
    getTitleTranslation: () => messages.freightDocumentTitle,
    getPrintDefaultMessageDescriptor: () => messages.freightDocumentPrintDefault,
    getFileNameTranslation: () => messages.freightDocumentFileName,
  },
};

export const excludeDefaultOption = ['hotkeys-and-barcode'];
